import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledBackButton = styled.button`
	height: 30px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	border: none;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledTypeButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 20px;
`;

const StyledPlayerList = styled.div`
	width: 100%;
`;

const StyledPlayerContainer = styled.div<{ $first: boolean }>`
	display: flex;
	align-items: ${(props) => (props.$first ? 'flex-start' : 'center')};
	justify-content: space-between;
	height: ${(props) => (props.$first ? '50px' : '70px')};

	& > ${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		margin-top: ${(props) => (props.$first ? '6px' : '0')};
	}
`;

const StyledMoneyInputContainer = styled.div`
	margin-top: 30px;
`;

const StyledGovSellContainer = styled.div`
	padding-top: 30px;
	height: 290px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 40px;
	margin-top: 30px;
`;

const StyledGovSellPriceContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	gap: 10px;
	align-items: center;
	margin-top: 30px;

	img {
		opacity: 0.5;
	}
`;

const StyledNoPlayersContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 220px;
`;

export {
	StyledBackButton,
	StyledButtonsContainer,
	StyledGovSellContainer,
	StyledGovSellPriceContainer,
	StyledMoneyInputContainer,
	StyledNoPlayersContainer,
	StyledPlayerContainer,
	StyledPlayerList,
	StyledTypeButtonsContainer,
};
